export const LANG_COOKIE_NAME = "langCode";
export const DEFAULT_LANGUAGE_CODE = "en";
export const SUPPORTED_LOCALES = ["hindi", "telugu", "tamil"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
const LANGUAGE_TAG_REGEX = /^[a-z]{2,8}(?:-[a-z0-9]{2,8})*$/;
const LANGUAGE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 7;

const LOCALE_TO_STORAGE_CODE: Record<string, string> = {
  hindi: "hi",
  telugu: "te",
  tamil: "ta",
};

const STORAGE_CODE_TO_LOCALE: Record<string, string> = {
  hi: "hindi",
  te: "telugu",
  ta: "tamil",
};

export const SUPPORTED_LANGUAGE_PREFIXES = ["hi", "te", "ta", "hindi", "telugu", "tamil"] as const;

export function mapStorageCodeToLocale(code: string): string {
  return STORAGE_CODE_TO_LOCALE[code.toLowerCase()] || code;
}
export function isSupportedLocale(locale: string): locale is SupportedLocale {
  return SUPPORTED_LOCALES.includes(locale as SupportedLocale);
}

export function mapLocaleToStorageCode(locale: string): string {
  return LOCALE_TO_STORAGE_CODE[locale.toLowerCase()] || locale;
}

export function resolveLanguageCode(languageCode?: string | null): string {
  const normalizedLanguageCode = languageCode?.trim().toLowerCase();

  if (!normalizedLanguageCode) {
    return DEFAULT_LANGUAGE_CODE;
  }

  if (!LANGUAGE_TAG_REGEX.test(normalizedLanguageCode)) {
    return DEFAULT_LANGUAGE_CODE;
  }

  return normalizedLanguageCode;
}

export function buildLanguageCookieValue(languageCode: string): string {
  const normalizedLanguageCode = resolveLanguageCode(languageCode);
  const secureAttribute =
    typeof window !== "undefined" && window.location.protocol === "https:" ? "; Secure" : "";

  return `${LANG_COOKIE_NAME}=${encodeURIComponent(normalizedLanguageCode)}; Path=/; Max-Age=${LANGUAGE_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${secureAttribute}`;
}

export function validateLocale(locale?: string | null): string | null {
  if (!locale) return null;

  const normalized = locale.trim().toLowerCase();
  if (!normalized || normalized === DEFAULT_LANGUAGE_CODE) return null;

  return isSupportedLocale(normalized) ? normalized : null;
}
